var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkageIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.947,
    height: 15.947,
    viewBox: "0 0 15.947 15.947",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "linkageIcon",
    transform: "translate(-1149.232 -509.228)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14668",
    "data-name": "Group 14668",
    transform: "translate(1149.732 509.728)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14667",
    "data-name": "Group 14667",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11353",
    "data-name": "Path 11353",
    d: "M1155.312,517.854a2.4,2.4,0,0,0-.992-.213,2.438,2.438,0,0,0-1.739.72l-2.129,2.13a2.449,2.449,0,1,0,3.465,3.463l2.136-2.129a2.447,2.447,0,0,0,.5-2.733m2.546-2.544a2.4,2.4,0,0,0,.992.213,2.434,2.434,0,0,0,1.738-.72l2.13-2.13a2.449,2.449,0,1,0-3.465-3.463l-2.136,2.129a2.447,2.447,0,0,0-.5,2.733",
    transform: "translate(-1149.732 -509.728)",
    fill: "var(--bgColor)",
    stroke: "var(--mainColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("line", {
    id: "Line_735",
    "data-name": "Line 735",
    x1: 7.298,
    y2: 7.298,
    transform: "translate(1153.556 513.552)",
    fill: "var(--bgColor)",
    stroke: "var(--mainColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_736",
    "data-name": "Line 736",
    x2: 15,
    y2: 15,
    transform: "translate(1149.732 509.675)",
    fill: "var(--bgColor)",
    stroke: "var(--mainColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkageIcon);
export default __webpack_public_path__ + "static/media/linkageIcon.4d8e5b04265a0e0cce5190c2bcdaf8bb.svg";
export { ForwardRef as ReactComponent };